import UnauthenticatedError from '../../api/helpers/UnauthenticatedError';
import {useSecurityStore} from '../../stores/securityStore';
import {useInformationStore} from '../../stores/informationStore';
import {allRequestsSettled} from '../../shared/composables/useDeviceStorage/capacitorStorage';
import type {NavigationGuardReturn, RouteLocationNormalized} from 'vue-router';
import {handleTokenRefresh} from '@/api/authentication/handleTokenRefresh';

/**
 * Runs initial refresh token / information call logic
 * @return {NavigationGuardResult}
 */
export async function refreshInformationData(
    to: RouteLocationNormalized
): Promise<NavigationGuardReturn> {
    const securityStore = useSecurityStore();
    const informationStore = useInformationStore();

    if (informationStore.isInitialized) {
        return;
    }

    // Special handling for routes that do not differentiate between
    // authenticated and unauthenticated users
    //
    // Currently only used of kiosk mode pages
    if (to.meta.skipTokenRefresh) {
        return;
    }

    // Wait until all ongoing (potential) async storage Get requests are settled
    // This is important for capacitor environments where storage access is async
    await allRequestsSettled();

    try {
        // manually call token refresh to prevent automatic token refresh during potential page reloads
        await handleTokenRefresh();
        await securityStore.refreshAccessToken();
    } catch (err) {
        if (!(err instanceof UnauthenticatedError)) {
            throw err;
        }
    }
}
